const API_BASE = String(import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');
const BASE = API_BASE;

export default {
  USER: {
    SINGLE: `${BASE}/profile`,
    LOGIN: `${BASE}/users/auth`,
    SEND_MESSAGE_MAIL: `${BASE}/users/email-confirm`,
    ACCEPT_AGREEMENT: `${BASE}/users/base`,
    RECOVER: `${BASE}/users/recovery`
  }
};
